import script from "./orionSavedVehiclesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./orionSavedVehiclesPage.vue?vue&type=script&setup=true&lang=ts"

import "./orionSavedVehiclesPage.vue?vue&type=style&index=0&id=1272064a&scoped=true&lang=scss"

import exportComponent from "C:\\agent\\_work\\1678\\s\\VCLWSAA\\source\\VCLWSAA.Presentation.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1272064a"]])

export default __exports__